<div class="modal" id="error-msg-popup" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="reloadOnClose()">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div class="error text-center">
                    <img src="./../../../assets/images/error.svg">
                    <p style="direction: ltr;">
                        {{msg}}
                    </p>
                </div>
                <div class="reload-wrapper">
                    <button *ngIf="reloadOnCloseFlag" class="btn btn-primary reload-btn" (click)="reloadOnClose()">{{'error-msg-popup.reload-btn' | translate}}</button>
                </div>
                <div *ngIf="showTextArray" class="text-array-wrapper text-center">
                    {{ textArray ? textArray.join(' , ') : '' }}
                </div>
                <div *ngIf="multibleLines" class="multible-lines-wrapper text-center">
                    <div *ngFor="let line of multibleLinesConfig?.lineConfig" [class]="line?.type">
                        {{ line?.translationKey | translate }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>